export default __webpack_public_path__ + "static/media/img.bbbf9616.png";